"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UILockBadge = _interopRequireDefault(require("UIComponents/badge/UILockBadge"));

var _UILockedFeature = _interopRequireDefault(require("ui-addon-upgrades/decorators/UILockedFeature"));

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _Scopes2 = require("lead-flows-ui/constants/Scopes");

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var DynoEditorActions = _interopRequireWildcard(require("lead-flows-ui/actions/DynoEditor"));

var _SimpleTextInput = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleTextInput"));

var _SimpleTextInputWithValidation = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleTextInputWithValidation"));

var _ContactProperties = require("lead-flows-ui/selectors/ContactProperties");

var _ConfigurationPropertyOptionsTableWrapper = _interopRequireDefault(require("lead-flows-ui/components/editor/ConfigurationPropertyOptionsTableWrapper"));

var DynoFormFieldEditorPanel =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(DynoFormFieldEditorPanel, _React$PureComponent);
  (0, _createClass2.default)(DynoFormFieldEditorPanel, null, [{
    key: "propTypes",
    get: function get() {
      return {
        formField: _react.default.PropTypes.object.isRequired,
        addValidationError: _react.default.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        editFormField: _react.default.PropTypes.func.isRequired,
        editFormFieldValidation: _react.default.PropTypes.func.isRequired,
        closeFormFieldEditor: _react.default.PropTypes.func.isRequired,
        contactProperties: _react.default.PropTypes.arrayOf(_react.default.PropTypes.object).isRequired,
        isAbleToUseCustomProperties: _react.default.PropTypes.bool.isRequired
      };
    }
  }]);

  function DynoFormFieldEditorPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DynoFormFieldEditorPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoFormFieldEditorPanel).call(this, props));
    _this.state = {
      blockedEmailDomainsValid: _this.validateBlockedEmailDomains(_this.getBlockedDomains())
    };
    _this.handleEmailDomainsToBlockValidation = _this.handleEmailDomainsToBlockValidation.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEmailDomainsToBlockUpdate = _this.handleEmailDomainsToBlockUpdate.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelectFieldOptionsChange = _this.handleSelectFieldOptionsChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DynoFormFieldEditorPanel, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowFormEditor.fieldEditor." + suffix;
    }
  }, {
    key: "handleEmailDomainsToBlockValidation",
    value: function handleEmailDomainsToBlockValidation(blocked) {
      var _this$props = this.props,
          removeValidationError = _this$props.removeValidationError,
          addValidationError = _this$props.addValidationError;
      var blockedEmailDomainsValid = this.validateBlockedEmailDomains(blocked);
      this.setState({
        blockedEmailDomainsValid: this.validateBlockedEmailDomains(blocked)
      });

      if (blockedEmailDomainsValid) {
        removeValidationError('emailDomainsToBlock');
      } else {
        addValidationError('emailDomainsToBlock', this.langKey('error.emailDomainsTooltip'));
      }
    }
  }, {
    key: "handleEmailDomainsToBlockUpdate",
    value: function handleEmailDomainsToBlockUpdate(value) {
      var _this$props2 = this.props,
          formField = _this$props2.formField,
          editFormFieldValidation = _this$props2.editFormFieldValidation;
      var blockedEmailDomainsValid = this.state.blockedEmailDomainsValid;
      var blockedEmailProviders = Boolean(value) ? value.split(',') : [];
      editFormFieldValidation(formField.name, {
        blockedEmailProviders: blockedEmailProviders
      });

      if (!blockedEmailDomainsValid) {
        this.handleEmailDomainsToBlockValidation(this.getBlockedDomains());
      }
    }
  }, {
    key: "getBlockedDomains",
    value: function getBlockedDomains() {
      return this.props.formField.validation ? this.props.formField.validation.blockedEmailProviders : [];
    }
  }, {
    key: "validateBlockedEmailDomains",
    value: function validateBlockedEmailDomains(blocked) {
      return !blocked.some(function (value) {
        var doesNotContainAtSymbol = value.indexOf('@') === -1;

        var allowsValidEmail = _EmailAddress.default.test("test@" + value.trim());

        return !(doesNotContainAtSymbol && allowsValidEmail);
      });
    }
  }, {
    key: "showEmailProviderOptions",
    value: function showEmailProviderOptions() {
      var formField = this.props.formField;
      return formField.name === 'email';
    }
  }, {
    key: "maybeRenderBlockFreeEmailProviders",
    value: function maybeRenderBlockFreeEmailProviders() {
      var _this2 = this;

      var _this$props3 = this.props,
          formField = _this$props3.formField,
          editFormFieldValidation = _this$props3.editFormFieldValidation;

      if (!this.showEmailProviderOptions()) {
        return null;
      }

      return _react.default.createElement(_UICheckbox.default, {
        checked: formField.validation ? formField.validation.defaultProvidersBlocked : false,
        onChange: function onChange(_ref) {
          var checked = _ref.target.checked;
          return _this2.maybeLockedOnChange(function () {
            return editFormFieldValidation(formField.name, {
              defaultProvidersBlocked: checked
            });
          });
        }
      }, this.renderLabelMessage('blockFreeEmailDomainsMessage'));
    }
  }, {
    key: "maybeRenderEmailDomainsToBlock",
    value: function maybeRenderEmailDomainsToBlock() {
      var _this3 = this;

      var blockedEmailDomainsValid = this.state.blockedEmailDomainsValid;

      if (!this.showEmailProviderOptions()) {
        return null;
      }

      var blockedDomains = this.getBlockedDomains();
      return _react.default.createElement(_SimpleTextInputWithValidation.default, {
        id: "dyno-form-field-domains-block",
        required: false,
        label: this.renderLabelMessage('emailDomainsToBlock'),
        labelTooltip: _I18n.default.text(this.langKey('emailDomainsToBlockTooltip')),
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          return _this3.maybeLockedOnChange(function () {
            return _this3.handleEmailDomainsToBlockUpdate(value);
          });
        },
        value: blockedDomains.join(),
        placeholder: _I18n.default.text(this.langKey('emailDomainsToBlockPlaceholder')),
        isInvalid: !blockedEmailDomainsValid,
        invalidMessage: blockedEmailDomainsValid ? null : _I18n.default.text(this.langKey('error.emailDomainsMessage')),
        onBlur: function onBlur() {
          return _this3.handleEmailDomainsToBlockValidation(blockedDomains);
        }
      });
    }
  }, {
    key: "maybeRenderPlaceholderInput",
    value: function maybeRenderPlaceholderInput() {
      var _this4 = this;

      var _this$props4 = this.props,
          formField = _this$props4.formField,
          editFormField = _this$props4.editFormField;

      if (formField.fieldType !== 'text' && formField.fieldType !== 'select') {
        return null;
      }

      return _react.default.createElement(_SimpleTextInput.default, {
        id: "dyno-form-field-placeholder",
        label: this.renderLabelMessage('fieldPlaceholder'),
        labelTooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('fieldPlaceholderTooltip')
        }),
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          return _this4.maybeLockedOnChange(function () {
            return editFormField(formField.name, {
              placeholder: value
            });
          });
        },
        value: formField.placeholder || '',
        showAsOptional: false
      });
    }
  }, {
    key: "handleSelectFieldOptionsChange",
    value: function handleSelectFieldOptionsChange(fieldName, _, attribute, value) {
      var editFormField = this.props.editFormField;

      switch (attribute) {
        case 'options':
          this.maybeLockedOnChange(function () {
            return editFormField(fieldName, {
              options: value
            });
          });
          break;

        case 'selectedOptions':
          this.maybeLockedOnChange(function () {
            return editFormField(fieldName, {
              selectedOptions: value
            });
          });
          break;

        default:
          break;
      }
    }
  }, {
    key: "maybeRenderSelectFieldOptions",
    value: function maybeRenderSelectFieldOptions() {
      var formField = this.props.formField;
      return _react.default.createElement("div", {
        className: "select-field-options"
      }, _react.default.createElement(_ConfigurationPropertyOptionsTableWrapper.default, {
        formField: formField,
        handleChange: this.handleSelectFieldOptionsChange
      }));
    }
  }, {
    key: "maybeRenderSimpleDefaultValueInput",
    value: function maybeRenderSimpleDefaultValueInput() {
      var _this5 = this;

      var numeric = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props5 = this.props,
          formField = _this$props5.formField,
          editFormField = _this$props5.editFormField;
      return _react.default.createElement(_SimpleTextInput.default, {
        id: "dyno-form-field-default-value",
        label: this.renderLabelMessage('fieldDefaultValue'),
        labelTooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('fieldDefaultValueTooltip')
        }),
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return _this5.maybeLockedOnChange(function () {
            return editFormField(formField.name, {
              defaultValue: value
            });
          });
        },
        value: formField.defaultValue || '',
        showAsOptional: false,
        numeric: numeric
      });
    }
  }, {
    key: "maybeRenderIsRequiredOption",
    value: function maybeRenderIsRequiredOption() {
      var _this6 = this;

      var _this$props6 = this.props,
          formField = _this$props6.formField,
          editFormField = _this$props6.editFormField;
      return formField.fieldType === 'booleancheckbox' ? _react.default.createElement(_UICheckbox.default, {
        checked: Boolean(formField.required),
        onChange: function onChange(_ref5) {
          var checked = _ref5.target.checked;
          return _this6.maybeLockedOnChange(function () {
            return editFormField(formField.name, {
              required: checked
            });
          });
        }
      }, this.renderLabelMessage('makeThisFieldRequired')) : null;
    }
  }, {
    key: "maybeRenderDefaultValueInput",
    value: function maybeRenderDefaultValueInput() {
      var formField = this.props.formField;

      if (this.showEmailProviderOptions()) {
        return null;
      }

      switch (formField.fieldType) {
        case 'select':
          return this.maybeRenderSelectFieldOptions();

        case 'number':
          return this.maybeRenderSimpleDefaultValueInput(true);

        case 'text':
        case 'textarea':
          return this.maybeRenderSimpleDefaultValueInput();

        default:
          return null;
      }
    }
  }, {
    key: "maybeLockedOnChange",
    value: function maybeLockedOnChange(onChange) {
      var isAbleToUseCustomProperties = this.props.isAbleToUseCustomProperties;

      if (isAbleToUseCustomProperties) {
        onChange();
      } else if (!this.lockedFeatureShowing) {
        this.lockedFeature.click();
      }
    }
  }, {
    key: "renderLabelMessage",
    value: function renderLabelMessage(key) {
      var isAbleToUseCustomProperties = this.props.isAbleToUseCustomProperties;

      var labelText = _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey(key)
      });

      return !isAbleToUseCustomProperties ? _react.default.createElement("span", null, labelText, _react.default.createElement(_UILockBadge.default, null)) : labelText;
    }
  }, {
    key: "renderContactPropertyName",
    value: function renderContactPropertyName() {
      var _this$props7 = this.props,
          formField = _this$props7.formField,
          contactProperties = _this$props7.contactProperties;
      var propName = contactProperties.find(function (prop) {
        return prop.name === formField.name;
      });
      return _react.default.createElement(_SimpleTextInput.default, {
        id: "dyno-form-field-propname",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('fieldPropName')
        }),
        value: propName.label,
        showAsOptional: false,
        readOnly: true
      });
    }
  }, {
    key: "renderLockedFeature",
    value: function renderLockedFeature() {
      var _this7 = this;

      return _react.default.createElement(_UILockedFeature.default, {
        upgradeData: {
          app: 'lead-flows',
          screen: 'editor',
          uniqueId: 'custom-leadflow-form-properties',
          upgradeProduct: 'marketing-starter'
        },
        modalKey: "leadflows-custom-props",
        modalMountDelay: 0
      }, _react.default.createElement("button", {
        style: {
          display: 'none'
        },
        ref: function ref(i) {
          _this7.lockedFeature = i;
        }
      }));
    }
  }, {
    key: "renderLabelInput",
    value: function renderLabelInput() {
      var _this8 = this;

      var _this$props8 = this.props,
          formField = _this$props8.formField,
          editFormField = _this$props8.editFormField;
      return _react.default.createElement(_SimpleTextInput.default, {
        id: "dyno-form-field-label",
        label: this.renderLabelMessage('fieldLabel'),
        labelTooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('fieldLabelTooltip')
        }),
        value: formField.label || '',
        onChange: function onChange(_ref6) {
          var value = _ref6.target.value;
          return _this8.maybeLockedOnChange(function () {
            return editFormField(formField.name, {
              label: value
            });
          });
        },
        showAsOptional: false
      });
    }
  }, {
    key: "renderBackButton",
    value: function renderBackButton() {
      var closeFormFieldEditor = this.props.closeFormFieldEditor;
      return _react.default.createElement(_UIBackButton.default, null, _react.default.createElement(_UILink.default, {
        onClick: closeFormFieldEditor
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('backToForm')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, this.renderBackButton(), this.renderContactPropertyName(), this.renderLabelInput(), this.maybeRenderPlaceholderInput(), this.maybeRenderDefaultValueInput(), this.maybeRenderEmailDomainsToBlock(), this.maybeRenderBlockFreeEmailProviders(), this.maybeRenderIsRequiredOption(), this.renderLockedFeature());
    }
  }]);
  return DynoFormFieldEditorPanel;
}(_react.default.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAbleToUseCustomProperties: (0, _Scopes.hasScope)(state, _Scopes2.LEAD_FLOWS_CUSTOM_FIELDS_ACCESS),
    contactProperties: (0, _ContactProperties.getProperties)(state)
  };
};

var actionsToBind = {
  editFormField: DynoEditorActions.editFormField,
  editFormFieldValidation: DynoEditorActions.editFormFieldValidation
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(DynoFormFieldEditorPanel);

exports.default = _default;
module.exports = exports.default;